<template>
    <el-container>
        <el-header>
            <el-form :inline="true" :model="formSync" ref="formSync" class="demo-form-inline" >
                <el-row> </el-row>
                <el-row>
                    <el-form-item :label="$t('common.SYSFLG')" :label-width="formLabelWidth" prop="sysFlg">
                        <td-select :options="sysList" keys="sSysFlg" text="sCaption" :placeholder="$t('common.PLEASE_SELECT')" v-model="formSync.sysFlg"></td-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item :label="$t('common.URL')" :label-width="formLabelWidth" prop="url">
                        <td-input v-model="formSync.url"></td-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item :label="$t('common.USER_INTERFACE')" :label-width="formLabelWidth" prop="userInterface">
                        <td-input v-model="formSync.userInterface"></td-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item :label="$t('common.ROLE_INTERFACE')" :label-width="formLabelWidth" prop="roleInterface">
                        <td-input v-model="formSync.roleInterface"></td-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item :label="$t('common.RELATION_INTERFACE')" :label-width="formLabelWidth" prop="relationInterface">
                        <td-input v-model="formSync.relationInterface"></td-input>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-form-item class="menuStyle">
                        <td-button @click="btnSave('formSync')" :loading="loading" type="primary">{{ $t('common.SAVE') }}</td-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </el-header>
    </el-container>
</template>
<script>
import api from './assets/api.js';
export default {
    components: {},
    created() {
        // 初始化系统标识下拉列表
        api.getSysList(JSON.stringify(''), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message.error(response.data.statusMessage);
                this.$log.error('sys/getSysList', response.data.statusMessage);
            }
            this.sysList = response.data.content;
            this.$log.error(this.sysList);
        });
    },
    data() {
        return {
            formSync: {
                sysFlg: '',
                url: '',
                userInterface: '',
                roleInterface: '',
                relationInterface: ''
            },
            // 对表单进行数据验证
            rules: {
                userInterface: [{ required: true, message: this.$t('error.ERROR_USER_URL_NULL'), trigger: 'blur' }, { pattern: this.$regex.SUB_URL, message: this.$t('error.ERROR_USER_URL_ILLEGAL') }],
                roleInterface: [{ required: true, message: this.$t('error.ERROR_ROLE_URL_NULL'), trigger: 'blur' }, { pattern: this.$regex.SUB_URL, message: this.$t('error.ERROR_ROLE_URL_ILLEGAL') }],
                url: [{ required: true, message: this.$t('error.ERROR_SYNC_URL_NULL'), trigger: 'change' }, { pattern: this.$regex.URL, message: this.$t('error.ERROR_SYNC_URL_ILLEGAL') }],
                relationInterface: [
                    { required: true, message: this.$t('error.ERROR_RELATION_URL_NULL'), trigger: 'blur' },
                    { pattern: this.$regex.SUB_URL, message: this.$t('error.ERROR_RELATION_URL_ILLEGAL') }
                ]
            },
            formLabelWidth: '150px',
            sysList: [],
            syncInfo: null,
            loading: false
        };
    },
    mounted() {
        this.querySyncInfo();
    },
    methods: {
        /* 角色信息查询 */
        btnSave(formName) {
            this.loading = true;
            let param = {
                User: this.formSync.userInterface,
                URL: this.formSync.url,
                Role: this.formSync.roleInterface,
                Relation: this.formSync.relationInterface,
                sysId: this.formSync.sysFlg
            };
            this.$log.error(param);
            api.updateSyncInfo(param, response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    this.$log.error('workFlowAuthor/updateSyncInfo', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('workFlowAuthor/updateSyncInfo', response.data.message);
                    this.loading = false;
                    return;
                }
                this.loading = false;
            });
        },
        querySyncInfo() {
            api.querySyncInfo('', response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({ type: 'error', showClose: true, message: this.$t('error.ERROR_RESPONSE') });
                    this.loading = false;
                    this.$log.error('workFlowAuthor/querySyncInfo', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('workFlowAuthor/querySyncInfo', response.data.message);
                    this.loading = false;
                    return;
                }
                this.syncInfo = response.data.content;
                this.formSync.sysFlg = this.syncInfo.sysId;
                this.formSync.url = this.syncInfo.url;
                this.formSync.userInterface = this.syncInfo.user;
                this.formSync.roleInterface = this.syncInfo.role;
                this.formSync.relationInterface = this.syncInfo.relation;
                this.$log.error(this.syncInfo);
            });
        },
        RoleDialogClose() {
            this.dialogRoleVisible = false;
        }
    }
};
</script>
<style>
.menuStyle {
    padding-left: 100px;
}
</style>
